// Push Notifications Constants

import type {CampaignCategory, CampaignStatus} from "@/types/push.types";

export const CAMPAIGN_CATEGORIES: {
  value: CampaignCategory;
  label: string;
  description: string;
}[] = [
  {
    value: "general",
    label: "General",
    description: "General announcements and updates",
  },
  {
    value: "transactional",
    label: "Transactional",
    description: "Transfer and payment notifications",
  },
  {
    value: "marketing",
    label: "Marketing",
    description: "Promotional campaigns and offers",
  },
  {
    value: "kyc",
    label: "KYC",
    description: "Identity verification reminders",
  },
  {
    value: "security",
    label: "Security",
    description: "Security alerts and updates",
  },
  {
    value: "promotion",
    label: "Promotion",
    description: "Special offers and discounts",
  },
];

export const CAMPAIGN_STATUSES: {
  value: CampaignStatus;
  label: string;
  color: string;
}[] = [
  {value: "draft", label: "Draft", color: "gray"},
  {value: "scheduled", label: "Scheduled", color: "blue"},
  {value: "sending", label: "Sending", color: "amber"},
  {value: "sent", label: "Sent", color: "green"},
  {value: "failed", label: "Failed", color: "red"},
  {value: "cancelled", label: "Cancelled", color: "gray"},
];

export const NOTIFICATION_SCREENS = [
  {value: "notifications", label: "Notification Inbox"},
  {value: "home", label: "Home Screen"},
  {value: "transfer-detail", label: "Transfer Detail"},
  {value: "kyc-onboarding", label: "KYC Onboarding"},
  {value: "deposit-detail", label: "Deposit Detail"},
  {value: "profile", label: "User Profile"},
  {value: "wallet", label: "Wallet"},
  {value: "transactions", label: "Transactions"},
];

export const KYC_STATUSES = [
  {value: "pending", label: "Pending"},
  {value: "in_progress", label: "In Progress"},
  {value: "completed", label: "Completed"},
  {value: "rejected", label: "Rejected"},
];

export const GENDER_OPTIONS = [
  {value: "M", label: "Male"},
  {value: "F", label: "Female"},
];

export const DEVICE_OPTIONS = [
  {value: "ios", label: "iOS (iPhone / iPad)"},
  {value: "android", label: "Android"},
];

// Common country codes (aligned with Countries module)
export const COMMON_COUNTRIES = [
  {code: "DO", name: "Dominican Republic"},
  {code: "US", name: "United States"},
  {code: "GT", name: "Guatemala"},
  {code: "SV", name: "El Salvador"},
  {code: "HN", name: "Honduras"},
  {code: "CR", name: "Costa Rica"},
  {code: "PA", name: "Panama"},
  {code: "NI", name: "Nicaragua"},
  {code: "MX", name: "Mexico"},
  {code: "CO", name: "Colombia"},
  {code: "VE", name: "Venezuela"},
  {code: "ES", name: "Spain"},
];

export const CAMPAIGN_VALIDATION = {
  TITLE_MAX_LENGTH: 200,
  BODY_MAX_LENGTH: 1000,
  MIN_SCHEDULE_MINUTES: 5,
  MAX_CAMPAIGNS_PER_PAGE: 100,
  DEFAULT_PAGE_SIZE: 20,
} as const;
